import { User } from '@choco-admin/types';
import { Card, CardBody, CardHeader } from '@heroui/react';
import React from 'react';

import { UserForm } from '../../UserForm';
import { UserFormData } from '../../UserForm/hooks/useUserFormValidation';

interface UserEditFormProps {
  initialFormData: Partial<UserFormData>;
  onSubmit: (values: UserFormData) => Promise<void>;
  isSubmitting: boolean;
  user: User;
  disabled?: boolean;
}

export const UserEditForm: React.FC<UserEditFormProps> = ({
  initialFormData,
  onSubmit,
  isSubmitting,
  user,
  disabled = false,
}) => {
  return (
    <Card className="bg-content1 border-default-200">
      <CardHeader>
        <h2 className="text-xl font-semibold text-foreground">
          {disabled ? 'User Information (Read Only)' : 'Edit User Information'}
        </h2>
      </CardHeader>
      <CardBody>
        <UserForm
          initialData={initialFormData}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          submitLabel="Update User"
          isEditMode={true}
          user={{
            id: user.id,
            name: user.name,
            profileImage: user.profileImageUrl
              ? { url: user.profileImageUrl }
              : null,
            isPuppy: user.isPuppy,
            supplierId: user.supplierId,
            supplierName: user.supplierName,
            supplierReferenceId: user.supplierReferenceId,
          }}
          userBuyers={user?.linkedBuyers || []}
          disabled={disabled}
        />
      </CardBody>
    </Card>
  );
};
